import React, {createRef, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import Loader from "components/UI/Loader";
import {useFetching} from "hooks/useFetching";
import {ApiServices} from "API";
import {AddressType, IAddress, IAddressTableData, PageType} from "API/types";
import ModalPagination from "components/UI/Modal/ModalPagination";
import icons from "components/UI/icons/icons";

const ModalViewVotes: React.FC = () => {
    const {IconArrowUpRight} = icons;
    const modalRef = createRef<HTMLDivElement>();
    const navigate = useNavigate();
    const params = useParams<"id">();
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState<PageType>(0);
    const [addressList, setAddressList] = useState<AddressType[]>([]);
    const [meta, setMeta] = useState<IAddressTableData>();

    const closeModal = () => {
        navigate(-1);
    };

    const keyDownHandler = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.code === "Escape") {
            closeModal()
        }
    };

    const getAddressByNominee = useFetching(async () => {
        if (params.id) {
            const response = await ApiServices.getAddressByNominee(+params.id, page);
            setMeta(response.data._meta);

            if (response.data.address) {
                setAddressList(response.data.address);
            }
        }
    }, setIsLoading);

    useEffect(() => {
        modalRef.current?.focus();
    }, []);

    useEffect(() => {
        getAddressByNominee();
    }, [page]);

    return (
        <div ref={modalRef} onKeyDown={keyDownHandler} onClick={closeModal} tabIndex={0} className="modal modal--open">
            <div onClick={(e) => e.stopPropagation()} className="modal__content">
                <p className="modal__title">Votes</p>
                {
                    isLoading
                        ? <Loader/>
                        : <>
                            {
                                addressList.length !== 0 ? <ul className="modal__address-list">
                                    {
                                        addressList.map((address: AddressType, index) => {
                                            return (<li className="small" key={index}>
                                                <a href={createOpeaseaLink(address)} target="_blank" rel="noreferrer" className="modal__address-link">
                                                    {address}
                                                    <IconArrowUpRight/>
                                                </a>
                                            </li>)
                                        })
                                    }
                                </ul> : <p>No Votes!</p>
                            }
                            {
                                meta && meta.total_count !== 0 && meta.page_count !== 1 && <ModalPagination setPage={setPage} meta={meta}/>
                            }
                        </>
                }
                <button className="modal__btn-close" onClick={closeModal}>Close</button>
            </div>
        </div>
    );
};

export default ModalViewVotes;

export const createOpeaseaLink = (address: AddressType) => {
    return `https://opensea.io/${address}?search[query]=iggyboy`;
};